<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div>
        <div class="display-1 font-weight-medium blue--text">
          <v-icon large>help</v-icon>
          Managing Health Facilities and Physicians
        </div>
      </div>
    </v-card-title>
    <v-card-text>
      <v-stepper v-model="step" vertical non-linear>
        <v-stepper-step editable step="1">
          <span class="blue--text" @click="openPage('help-signin')">Sign in</span> and click on "Health Facilities" item under the "Users" menu.
        </v-stepper-step>

        <v-stepper-content step="1">
          <v-card class="mb-5">
            <img src="~assets/images/help_userfacility_1.png">
          </v-card>
          <v-btn color="primary" @click="step = 2">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="2">
          Inform the Physician ID (Only Admins allowed)
          <small>Either fill in the Physician ID in the text box, or click on the QRCode button.</small>
        </v-stepper-step>

        <v-stepper-content step="2">
          <v-card class="mb-5">
            <img src="~assets/images/help_userfacility_2a.png">
          </v-card>
          <v-btn color="primary" @click="step = 3">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="3">
          Read the QRCode
          <small>If you have clicked on the QRCode button, point the Physician ID QRCode to your camera.</small>
        </v-stepper-step>

        <v-stepper-content step="3">
          <v-card class="mb-5">
            <img src="~assets/images/help_userfacility_3a.png">
          </v-card>
          <v-btn color="primary" @click="step = 4">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="4">
          Manage Facilities
          <small>
            If the scanned ID is a valid Physician, the screen will show their current assigned facilities.
            <br>
            Physicians can be assigned to a maximum of 4 facilities simultaneously.
            <br>
            In here you can add new facilities by clicking on the blue button (check next step).
            <br>
            You can also unassign facilities from the selected Physician by clicking on the trash icon by the facility name.
          </small>
        </v-stepper-step>

        <v-stepper-content step="4">
          <v-card class="mb-5">
            <img src="~assets/images/help_userfacility_4a.png">
          </v-card>
          <v-btn color="primary" @click="step = 5">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-step editable step="5">
          Add Facilities to Physician
          <small>
            After clickin on the "Add Facility" button, you can add a specific facility to the Physician record by either typing the Facility ID or scanning the Facility QRCode, and then clicking on the "+" icon in the text field.
          </small>
        </v-stepper-step>

        <v-stepper-content step="5">
          <v-card class="mb-5">
            <img src="~assets/images/help_userfacility_5a.png">
          </v-card>
          <v-btn color="primary" @click="step = 1">Back to start</v-btn>
          <v-btn flat @click="openPage('help')">Back to help</v-btn>
        </v-stepper-content>

      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<style>
  .cursor:hover{
    cursor: pointer;
  }
</style>

<script>
export default {
  props: ['localUserType'],
  data () {
    return {
      localUserType: this.localUserType,
      step: 1
    }
  },
  methods: {
    openPage(name) {
      this.$emit("openPage", name);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/controllers/Help-Userfacilitiesadmin.vue